import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import "./i18n/index.js";
import { AppShell } from "./app/index.js";

const host = document.getElementById("root");
if (host === null) throw new Error("#root is missing from index.html");

createRoot(host).render(
  <StrictMode>
    <AppShell />
  </StrictMode>,
);
